import ReducerUtils from "../../../utils/ReducerUtils"
import Actions from "../../../model/constant/actions"

const MarketingEvents = ReducerUtils.createReducer<boolean>(false,{
  [Actions.RETRIEVING_MARKETING_EVENTS] : (state, action)=>action.status
})

export default MarketingEvents
